// extracted by mini-css-extract-plugin
export var label = "_cw-5";
export var slideContainer = "_cw-0";
export var slider = "_cw-1";
export var sliderLg = "_cw-4";
export var sliderMd = "_cw-3";
export var sliderSm = "_cw-2";